import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';
import { UserGroupMember } from 'types/user_group';

import { useAPI } from 'hooks/api/useAPI';

export type AddUserGroupMemberParams = {
  groupId: string;
  account_id: string;
};

export function useAddUserGroupMember({
  onSettled,
  ...options
}: UseMutationOptions<
  UserGroupMember,
  APIError,
  AddUserGroupMemberParams
> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async ({ groupId, account_id }) => {
      const { data } = await client.post<UserGroupMember>(
        `/apps/${applicationID}/user_groups/${groupId}/members`,
        { account_id }
      );
      return data;
    },
    {
      ...options,
      onSettled(...args) {
        onSettled?.(...args);
        queryClient.invalidateQueries(['user-group-members']);
        queryClient.invalidateQueries(['user-groups']);
      },
    }
  );
}
